module.exports = __webpack_public_path__ + "static/digital-titan-mag-cee7765bf35f2b25761a728c5a6dc897.jpg";